const otherPaymentType = [
  { key: '001', value: 'Reintegro de ISR pagado en exceso (siempre que no haya sido enterado al SAT).' },
  { key: '002', value: 'Subsidio para el empleo (efectivamente entregado al trabajador).' },
  { key: '003', value: 'Viáticos (entregados al trabajador).' },
  { key: '004', value: 'Aplicación de saldo a favor por compensación anual.' },
  { key: '005', value: 'Reintegro de ISR retenido en exceso de ejercicio anterior (siempre que no haya sido enterado al SAT).' },
  { key: '006', value: 'Alimentos en bienes (Servicios de comedor y comida) Art 94 último párrafo LISR.' },
  { key: '007', value: 'ISR ajustado por subsidio.' },
  { key: '008', value: 'Subsidio efectivamente entregado que no correspondía (Aplica sólo cuando haya ajuste al cierre de mes en relación con el Apéndice 7 de la guía de llenado de nómina).' },
  { key: '009', value: 'Reembolso de descuentos efectuados para el crédito de vivienda.' },
  { key: '999', value: 'Pagos distintos a los listados y que no deben considerarse como ingreso por sueldos, salarios o ingresos asimilados.' },

];

module.exports = otherPaymentType;
